
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { SessionContextProvider } from '@supabase/auth-helpers-react'
import { supabase } from './integrations/supabase/client'
import App from './App.tsx'
import './index.css'
import { initSentry } from './integrations/sentry/client'
import { initPostHog } from './integrations/posthog/client'

// Initialize Sentry as early as possible
initSentry();

// Initialize PostHog for analytics and session recording
initPostHog();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
    },
  },
})

createRoot(document.getElementById("root")!).render(
  <QueryClientProvider client={queryClient}>
    <SessionContextProvider supabaseClient={supabase}>
      <App />
    </SessionContextProvider>
  </QueryClientProvider>
);
